import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const { resetPassword } = constantsData.forms.auth;
const {
    confirmPassword: confirmPasswordFieldName,
    password: passwordFieldName,
} = formFieldNamesData;

export const resetPasswordFormData = [
    {
        label: resetPassword.password.label,
        name: passwordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
    {
        label: resetPassword.confirmPassword.label,
        name: confirmPasswordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
];
